import { loadFromModuleCollectionImplementation } from '../rootModules';
import { configureDynamicStoreBase } from './storeConfigure.base';
export class StoreConfiguratorNoDebug {
    constructor() {
        this.buildDynamic = (initialState, context, dynamicStore, componentReduxModules, history) => {
            return configureDynamicStoreBase(initialState, context, dynamicStore, componentReduxModules, history);
        };
    }
    loadFromModuleCollection(componentName, initialState) {
        return loadFromModuleCollectionImplementation(componentName, initialState);
    }
}
